import React, { useState } from "react";
import FarmerLayout from "../../components/layouts/FarmerLayout";
import { askGemini } from "../../services/geminiService";

const FarmerAI = () => {
  const [messages, setMessages] = useState([
    {
      role: "assistant",
      text:
        "Hello! I'm your AI assistant. Ask anything about milk production, feeding, hygiene, cattle health, or dairy tips.",
    },
  ]);

  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    if (!input.trim() || loading) return;

    const farmerMsg = { role: "user", text: input };

    // Add user's message
    setMessages((prev) => [...prev, farmerMsg]);

    const question = input;
    setInput("");
    setLoading(true);

    // Call Gemini API
    const aiReply = await askGemini(
      `
You are an AI assistant for dairy farmers in Kenya.
Give practical advice related to milk production, feeding, hygiene, cattle management, diseases, food ratios, and dairy best practices.

Farmer's question: "${question}"

Make your answer simple and actionable.
`
    );

    // Add AI response
    setMessages((prev) => [
      ...prev,
      { role: "assistant", text: aiReply },
    ]);

    setLoading(false);
  };

  return (
    <FarmerLayout>
      <div className="p-6 flex flex-col h-[calc(100vh-80px)]">
        <h1 className="text-2xl font-bold text-green-700 mb-2">
          AI Assistant
        </h1>

        <p className="text-gray-600 mb-4">
          Ask questions related to milk production, feeding, hygiene, diseases, or general dairy farming advice.
        </p>

        {/* Chat Window */}
        <div className="flex-1 bg-white rounded-xl shadow p-4 overflow-y-auto border">
          {messages.map((msg, index) => (
            <div
              key={index}
              className={`mb-4 flex ${
                msg.role === "user" ? "justify-end" : "justify-start"
              }`}
            >
              <div
                className={`px-4 py-2 rounded-xl max-w-[75%] ${
                  msg.role === "user"
                    ? "bg-green-600 text-white"
                    : "bg-gray-200 text-gray-800"
                }`}
              >
                {msg.text}
              </div>
            </div>
          ))}

          {loading && (
            <div className="text-gray-500 text-sm italic">AI is thinking...</div>
          )}
        </div>

        {/* Input Section */}
        <div className="mt-4 flex gap-2">
          <input
            type="text"
            placeholder="Ask your question..."
            className="flex-1 border rounded-xl px-4 py-2"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSend()}
          />
          <button
            onClick={handleSend}
            disabled={loading}
            className="bg-green-600 text-white px-6 py-2 rounded-xl disabled:bg-green-300"
          >
            {loading ? "Sending..." : "Send"}
          </button>
        </div>
      </div>
    </FarmerLayout>
  );
};

export default FarmerAI;
